/*
 * Copyright (c) 2021. Revo Digital
 * ---
 * Author: gabriele
 * File: array.ts
 * Project: mle-client
 * Committed last: 2021/11/28 @ 1928
 * ---
 * Description:
 */

/**
 * Inverte due indici di un vettore
 * @param s Indice di partenza
 * @param e Indice di fine
 * @param arr Array
 */
export const swapByIndex = <T>(s: number, e: number, arr: Array<T>) => {
  const temp = arr[s];
  arr[s] = arr[e];
  arr[e] = temp;
};

/**
 * Converte una mappa in un oggetto
 * @param map
 */
export const mapToObject = <T, Y>(map: Map<T, Y>) => {
  return Object.fromEntries(map.entries());
};

/**
 * Convert an object to a map
 * @param obj
 */
export const objectToMap = <T>(obj: Object) => {
  return new Map(Object.entries(obj));
};